import React, {useState} from 'react';
import {ContractProjectHeader} from "../../containers/ContractProjectHeader/ContractProjectHeader";
import {Container} from "../../components/Container/Container";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import {createNormativeDocumentsFromJson, listToTree} from "../../utils/handbookLoad";

function readFile(file, onLoad) {
    const reader = new FileReader()
    reader.onload = function(evt) {
        onLoad(evt.target.result)
    }
    reader.readAsText(file)
}

export const DocumentUploadPage = () => {
    const [jsonFile, setJsonFile] = useState(null)

    const onFileLoad = result => {
        setJsonFile(listToTree(JSON.parse(result)))
    }

    const onFileChange = e => readFile(e.target.files[0], onFileLoad)

    const onFilesSave = async () => await createNormativeDocumentsFromJson(jsonFile)

    return <>
        <ContractProjectHeader/>
        <Container>
            <Paper style={{padding: '16px'}}>
                <Grid container direction={'column'} spacing={3}>
                    <Grid item>
                        <input
                            color="primary"
                            accept="application/json"
                            type="file"
                            onChange={onFileChange}
                            id="icon-button-file-1"
                            style={{display: 'none'}}
                        />
                        <label htmlFor="icon-button-file-1">
                            <Button
                                variant="contained"
                                size="small"
                                component="span"
                                color="primary"
                            >
                                JSON файл справочника
                            </Button>
                        </label>
                        {jsonFile ? <CheckIcon style={{color: 'green'}}/> : <CloseIcon style={{color: 'red'}}/>}
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            size="small"
                            component="span"
                            color="primary"
                            disabled={!Boolean(jsonFile)}
                            onClick={onFilesSave}
                        >
                            Сохранить
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    </>
}